import React, { useState } from 'react'
import { format } from 'date-fns'
import { Plus, Repeat } from 'lucide-react'
import { Button, DataTable, EmptyState, SectionHead, StatusPill } from '../../components/ui'
import { InlineConfirm, Swatch, WEEKDAYS } from './shared'

function AgreementsTab({ agreements, onNew, onEnd, courtStyle }) {
  const [asking, setAsking] = useState(null)
  const [busy, setBusy] = useState(false)

  const confirmEnd = async (a) => {
    setBusy(true)
    try {
      await onEnd(a)
    } finally {
      setBusy(false)
      setAsking(null)
    }
  }

  const columns = [
    {
      key: 'person',
      header: 'Person',
      render: (a) => (
        <div className="stack-sm rt-cell">
          <span className="cell-title">{a.displayName}</span>
          {a.phone ? <span className="cell-sub mono">{a.phone}</span> : null}
        </div>
      )
    },
    {
      key: 'title',
      header: 'Tittel',
      render: (a) => (
        <div className="rt-cell">
          <span className="rt-cell-strong">{a.title}</span>
          {a.courtName ? (
            <span className="cell-sub rt-court-tag">
              {a.courtId && <Swatch style={courtStyle(a.courtId)} size={10} />}
              {a.courtName}
            </span>
          ) : null}
        </div>
      )
    },
    {
      key: 'when',
      header: 'Når',
      className: 'cell-mono',
      render: (a) => `${a.weekdays.map((d) => WEEKDAYS[d - 1]?.label).join(', ')} ${a.startTime}–${a.endTime}`
    },
    {
      key: 'period',
      header: 'Periode',
      className: 'cell-mono muted',
      render: (a) => `${format(new Date(a.startDate), 'd.M.yy')} – ${format(new Date(a.endDate), 'd.M.yy')}`
    },
    {
      key: 'left',
      header: 'Gjenstår',
      render: (a) => (a.active ? <span className="rt-cell-strong">{a.occurrenceCount} ganger</span> : <StatusPill tone="muted">Avsluttet</StatusPill>)
    },
    {
      key: 'action',
      header: 'Handling',
      align: 'right',
      render: (a) => {
        if (!a.active) return null
        if (asking === a.id) {
          return (
            <InlineConfirm
              label="Bekreft avslutning"
              className="rt-confirm-cell"
              message={`Avslutte avtalen «${a.title}» med ${a.displayName}? Fremtidige ganger avlyses.`}
              confirmLabel="Avslutt"
              onConfirm={() => confirmEnd(a)}
              onCancel={() => setAsking(null)}
              busy={busy}
            />
          )
        }
        return <Button variant="danger-outline" size="sm" onClick={() => setAsking(a.id)}>Avslutt</Button>
      }
    }
  ]

  return (
    <div className="stack-lg">
      <SectionHead
        title="Faste avtaler"
        subtitle="Ukentlige bookinger for faste leietakere."
        actions={<Button variant="primary" icon={Plus} onClick={onNew}>Ny avtale</Button>}
      />
      {agreements.length === 0 ? (
        <EmptyState icon={Repeat} title="Ingen faste avtaler ennå." />
      ) : (
        <DataTable columns={columns} rows={agreements} minWidth={900} caption="Faste avtaler" />
      )}
    </div>
  )
}

export default AgreementsTab
